import supabase from "./supabase";
import { toast } from "react-toastify";

export async function deleteAssignment(
  assignmentId: string,
  userId: string
): Promise<{ success: boolean; error?: string }> {
  try {
    const { error: assignmentError } = await supabase
      .from("assignments")
      .delete()
      .eq("id", assignmentId)
      .eq("user_id", userId);

    if (assignmentError) {
      console.error("Error deleting assignment:", assignmentError);
      return { success: false, error: "Failed to delete assignment" };
    }

    toast.success("Assignment deleted successfully");
    return { success: true };
  } catch (error) {
    console.error("Error in deleteAssignment:", error);
    return { success: false, error: "An unexpected error occurred" };
  }
}
